// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1QKR3","Slide":"style__Slide___3ec1D","SlideInner":"style__SlideInner___3H1UD"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/carousel/basic/center/style.css
// module id = 1454
// module chunks = 0